/*  ========================================================================
    # Hooks - Use Localization
    ========================================================================  */

/**
 * How to use:
 * const localize = useLocalization();
 * localize('svgSprite')
 *
 * @returns {string}
 */
export default function useLocalization() {
  const localization = window.jsLocalize || {};
  return key => localization[key] || '';
}
